// Session-wide lock for the "Piano di Cura" pages.
// When locked, the user is always redirected to the locked page (clinico or
// ortodonzia) regardless of what URL they try. The state persists across
// refreshes but is cleared on login (AuthContext.login / loginWithGoogle
// purge it before setting the new user).
//
// Storage is localStorage under a dedicated key. Value is one of:
//   "clinico"      → locked on Piano di Cura Reparto Clinico
//   "ortodonzia"   → locked on Piano di Cura Ortodonzia
//   null / missing → unlocked

const KEY = "bdd_piano_lock";

export function getPianoLock() {
  try {
    const v = localStorage.getItem(KEY);
    return v === "clinico" || v === "ortodonzia" ? v : null;
  } catch (err) {
    // Safari private mode / quota errors: treat as "no lock" rather than crash.
    console.warn("piano-lock: getPianoLock failed", err);
    return null;
  }
}

export function setPianoLock(mode) {
  try {
    if (mode === "clinico" || mode === "ortodonzia") {
      localStorage.setItem(KEY, mode);
    } else {
      localStorage.removeItem(KEY);
    }
  } catch (err) {
    // Storage unavailable — lock becomes session-only, not a fatal error.
    console.warn("piano-lock: setPianoLock failed", err);
  }
  // Notify listeners in the same tab (the native `storage` event only fires
  // on OTHER tabs, so we dispatch a custom event for the current one).
  try {
    window.dispatchEvent(new CustomEvent("bdd-piano-lock-change", { detail: mode || null }));
  } catch (err) {
    // Older browsers without CustomEvent — ignore.
    console.warn("piano-lock: dispatch failed", err);
  }
}

export function clearPianoLock() {
  setPianoLock(null);
}
